import React from 'react';
import classes from './CustomCheckboxV2.module.scss';
import classNames from 'classnames';

const CustomCheckboxV2 = ({ checked, name, id, className, onChange, value }) => {
    return (
        <label
            className={classNames(classes.checkbox, className)}
            htmlFor={id}
        >
            <input
                type="checkbox"
                id={id}
                name={name}
                checked={checked}
                onChange={onChange}
                value={value}
            />
        </label>
    );
};

export default CustomCheckboxV2;
